<ol class="breadcrumb">
  <li class="breadcrumb-item"><a routerLink="/providers">Transport Companies</a></li>
  @if (providerData.active) {
    <li class="breadcrumb-item"><a routerLink="/providers">Approved</a></li>
  }
  @if (!providerData.active) {
    <li class="breadcrumb-item"><a routerLink="/providers-pending">Pending</a></li>
  }
  <li class="breadcrumb-item active">{{providerData.name}}</li>
</ol>

<h1>{{providerData.name}}</h1>

<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link"
      routerLink="/providers/{{providerData.id}}"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }">
      <app-icon icon="package" iconClass="button-icon"></app-icon> Details
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link"
      routerLink="/providers/{{providerData.id}}/users"
      routerLinkActive="active">
      <app-icon icon="loader" iconClass="button-icon"></app-icon> Users
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link"
      routerLink="/providers/{{providerData.id}}/reports"
      routerLinkActive="active">
      <app-icon icon="loader" iconClass="button-icon"></app-icon> Reports
    </a>
  </li>
</ul>
@if (route.snapshot.routeConfig.path === 'providers/:id') {
  <div class="row">
    <div class="col-sm-12">
      <provider-general-information [data]="providerData" (onUpdate)="onUpdate($event)"></provider-general-information>
      <hr>
        <provider-contact-information
          [providerId]="providerData.id"
          [contactInformation]="contactInformation">
        </provider-contact-information>
        <hr>
          <provider-dispatcher-information [data]="providerData"></provider-dispatcher-information>
          <hr>
            <provider-service-areas [providerId]="providerData.id"
              [serviceAreas]="providerData.stateCounties"
              [states]="states">
            </provider-service-areas>
            <hr>
              <provider-service-schedule
                [providerId]="providerData.id"
                [data]="providerData.properties">
              </provider-service-schedule>
              <hr>
                <app-service-fees-edit [data]="providerData" [vehicleTypes]="vehicleTypes" [vehicleValueTypeMap]="vehicleValueTypeMap"></app-service-fees-edit>
                <hr>
                  @if (files) {
                    <div class="well">
                      <h3>Uploaded Files</h3>
                      <div class="row">
                        @for (file of files; track file) {
                          <div class="col-md-3 text-center">
                            <a (click)="openFile(providerData.id, file.id)" target="_blank" class="btn btn-link">
                              <app-icon icon="file" icon-class="file-icon"></app-icon>
                              <p>{{file.name}}</p>
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div class="row action-wrap">
                    <div class="col">
                      @if (!providerData.active) {
                        <button type="button"
                          class="btn btn-primary"
                          (click)="approveProvider()">
                          Approve Provider
                        </button>
                      }
                      <button type="button"
                        class="btn btn-danger"
                        (click)="confirmProviderDeleteModal()">
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }

